import { Component, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { forkJoin } from 'rxjs';
import { TrucksService, MobileTrackerDevice, Truck } from 'src/app/transportation/trucks/trucks.service';
import { Router } from '@angular/router';
import _ from 'lodash';
import { PgTitleComponent } from '../../../shared/components/title-bar/title-bar.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AuthenticationModule } from 'src/app/authentication/authentication.module';
import { AgGridModule } from 'ag-grid-angular';
import { TruckToolbarComponent } from '../trucks-toolbar/truck-toolbar/truck-toolbar.component';
import { GridOptions, GridReadyEvent, ICellRendererParams } from 'ag-grid-community';
import { AgGridService } from 'src/app/shared/ag-grid/ag-grid.service';

@Component({
  selector: 'app-gps-list',
  templateUrl: './gps-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule, AuthenticationModule, AgGridModule],
})
export class GpsListComponent implements OnInit, PgTitleComponent {

  title = new EventEmitter<string>();
  toolbarComponentType = TruckToolbarComponent;
  toolbarComponent: any;

  gridOptions: GridOptions = {};

  activeTracker!: any[];
  trackers!: MobileTrackerDevice[];
  trackersCashe: {
    [key: string]: MobileTrackerDevice;
  } = {};

  constructor(private _truckService: TrucksService,
    private _router: Router) { }

  columnDefs = [
    { headerName: 'شماره دستگاه ردیاب پلاک', field: 'imei' },

    { headerName: 'شماره همراه ردیاب', field: 'mobileNumber' },

    { headerName: 'نوع ردیاب', field: 'trackerType',
      cellRenderer: (params:ICellRendererParams) => {
        if(params.data.trackerType === 'VenusProvider') {
          return 'ونوس';
        } else if(params.data.trackerType === 'JupiterProvider') {
          return 'ژوپیتر';
        } else if(params.data.trackerType === 'KvlProvider') {
          return 'کاوشکام';
        }
      },
    },

    { headerName: 'وضعیت', cellRenderer: (params:ICellRendererParams) => this.checkTracker(params.data) },

  ];

  ngOnInit() {
    this.title.emit('Trackers');
    this.gridOptions = AgGridService.getOptions();
    forkJoin([
      this._truckService.getAllTracker(),
      this._truckService.getForLpgDist()
    ]).subscribe(result => {
      this.trackers = result[0];
      this.trackersCashe = this.trackerMap(result[1]);

      this.activeTracker = this.trackers;
      this.toolbarComponent.url = 'trucks/tracker';
    });
  }

  gridSetting(event: GridReadyEvent) {
    AgGridService.setting(event);
  }

  editRecord(tracker: MobileTrackerDevice) {
    this._router.navigate(['trucks/tracker', tracker.imei]);
  }

  trackerMap(trucks: Truck[]) {
    const usedTrackers = trucks.filter(truck => truck.tracker && truck.tracker.associatedObject.imei !== '').map(t => t.tracker);
    const grouped = _.groupBy(usedTrackers, (item) => item?.associatedObject.imei);
    return _(grouped).map((items, key) => (
      {
        imei: key
      }
    )).value().reduce((hashMap: Record<string, any>, data) => {
      hashMap[data.imei] = data;
      return hashMap;
    }, {});
  }

  checkTracker(tracker: MobileTrackerDevice) {
    return (this.trackersCashe[tracker.imei]) ? 'used' : 'notUsed';
  }
}
